module.exports = __webpack_public_path__ + "img/bonCadeau.0d4288de.webp";